export default __webpack_public_path__ + "static/media/ductBank4.2ba9c3d1.jpg";